import { Box, ClearIcon, Input, InputProps } from '@modusign/design-system';
import { forwardRef, ReactNode, useRef } from 'react';

import mergeRefs from '@libs/mergeRefs';

interface ContactCustomInputProps extends InputProps {
  prefixNode?: { element: ReactNode; width: string };
  onClear?: () => void;
}

const ContactCustomInput = forwardRef<HTMLInputElement, ContactCustomInputProps>(
  ({ prefixNode, onClear, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>();

    return (
      <Box sx={{ position: 'relative' }}>
        {prefixNode && prefixNode.element}
        <Input
          {...props}
          ref={mergeRefs(inputRef, ref)}
          sx={{ paddingLeft: prefixNode?.width, paddingRight: onClear ? '40px' : undefined }}
        />
        {onClear && (
          <Box
            as="button"
            sx={{
              position: 'absolute',
              right: 3,
              top: 2,
            }}
            onClick={() => {
              inputRef.current?.focus();
              onClear();
            }}
          >
            <ClearIcon />
          </Box>
        )}
      </Box>
    );
  }
);

export default ContactCustomInput;
